export default "__VITE_ASSET__Cam8nG3H__"